@if (learner?.email) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group-row">
      <span class="field-label" translate>agent-retake-document.form.face-photo</span>
      <label class="switch">
        <input type="checkbox" formControlName="facePhoto" />
        <span class="slider round"></span>
      </label>
    </div>

    @if (form.value.facePhoto) {
      <div class="form-group">
        <label for="item" class="field-label" translate>agent-retake-document.form.face-photo-reason</label>
        <textarea formControlName="facePhotoReason" rows="3" class="full-width"></textarea>
      </div>
    }

    <div class="form-group-row">
      <span class="field-label" translate>agent-retake-document.form.id-photo</span>
      <label class="switch">
        <input type="checkbox" formControlName="idPhoto" />
        <span class="slider round"></span>
      </label>
    </div>

    @if (form.value.idPhoto) {
      <div class="form-group">
        <label for="item" class="field-label" translate>agent-retake-document.form.id-photo-reason</label>
        <textarea formControlName="idPhotoReason" rows="3" class="full-width"></textarea>
      </div>
    }

    <div class="form-actions">
      <button type="button" class="button" (click)="onCancel()" translate>agent-retake-document.form.cancel</button>
      <button type="submit" [disabled]="!this.form.valid" class="button is-success" translate>
        agent-retake-document.form.submit
      </button>
    </div>
  </form>
} @else {
  <h3 translate>agent-retake-document.no-email.title</h3>
  <p translate>agent-retake-document.no-email.content</p>

  <div class="form-actions">
    <button type="button" class="button" (click)="onCancel()" translate>agent-retake-document.form.cancel</button>
  </div>
}
